import React from "react";
import DayStreak from "./DayStreak";
import "../MilestonePage.css";

/** Browser preview for `DayStreak` — see route `/day-streak-preview`. */
function DayStreakPage() {
  return (
    <main className="milestone-page">
      <div className="milestone-page__content">
        <DayStreak />
      </div>
    </main>
  );
}

export default DayStreakPage;
